'use es6';

import { List, Record } from 'immutable';
import { AudienceSourcesToAudienceType, SyncingStatus, AudienceTypes, Networks } from '../../lib/Constants';
import AudienceNetworkStateRecord from './AudienceNetworkStateRecord';
import { isAudienceMatchSizeTooSmall } from 'AdsUI/lib/AudienceUtils';
import TargetingAudienceRecord, { AudienceSourceApp } from './TargetingAudienceRecord';
import I18n from 'I18n';
import WorkflowReferenceRecord from './WorkflowReferenceRecord';
import AdSequencesRecord from './AdSequencesRecord';
export const AudienceTypePaths = {
  WEBSITE: 'audiences.listTypes.websiteList',
  CONTACT_LIST: 'audiences.listTypes.contactList',
  LOOKALIKE: 'audiences.listTypes.lookalikeList',
  COMPANY_LIST: 'audiences.listTypes.companyList'
};
export default class AudienceRecord extends Record({
  networkState: null,
  targetingAudience: null,
  objectListInfo: null,
  syncedContacts: null,
  adSequences: [],
  workflows: []
}) {
  constructor({
    networkState,
    targetingAudience,
    objectListInfo,
    syncedContacts,
    adSequences = [],
    workflows = []
  }) {
    const audienceObj = {
      adSequences: List(adSequences.map(adSequence => new AdSequencesRecord(adSequence))),
      networkState: new AudienceNetworkStateRecord(networkState),
      targetingAudience: new TargetingAudienceRecord(targetingAudience),
      objectListInfo,
      syncedContacts,
      workflows: List(workflows.map(workflow => new WorkflowReferenceRecord(workflow)))
    };
    super(audienceObj);
  }

  get id() {
    return this.targetingAudience.id;
  }

  get type() {
    return AudienceSourcesToAudienceType[this.targetingAudience.audienceSource];
  }

  get lastSyncTime() {
    return this.targetingAudience.lastSyncedAt;
  }

  get syncingStatus() {
    if (this.type === AudienceTypes.CONTACT_LIST || this.type === AudienceTypes.COMPANY_LIST) {
      if (this.targetingAudience.audienceSyncErrorReason) {
        return SyncingStatus.SYNCING_ERROR;
      }

      if (this.targetingAudience.adNetwork === Networks.LINKEDIN) {
        if ((this.networkState.errorMessage === 'PROCESSING' || this.networkState.errorMessage === 'BUILDING') && this.networkState.approximateSize > 300) {
          return SyncingStatus.MATCHING;
        } else if (this.networkState.errorMessage === 'ARCHIVED') {
          return SyncingStatus.ARCHIVED;
        } else if (isAudienceMatchSizeTooSmall(this)) {
          return SyncingStatus.NOT_READY;
        } else {
          return SyncingStatus.READY;
        }
      } else if (this.objectListInfo && this.syncedContacts < this.objectListInfo.size) {
        return SyncingStatus.SYNCING_IN_PROGRESS;
      } else {
        return SyncingStatus.READY;
      }
    } else {
      return null;
    }
  }

  getFormattedType() {
    if (this.type === AudienceTypes.CONTACT_LIST && this.targetingAudience.audienceSourceApp === AudienceSourceApp.WORKFLOW) {
      return I18n.text('audiences.listTypes.workflowContactList');
    }

    return I18n.text(AudienceTypePaths[this.type]);
  }

  get isArchived() {
    return this.networkState.errorMessage === 'ARCHIVED';
  }

}